import { render, staticRenderFns } from "./AdminSupportMessageResource.vue?vue&type=template&id=7f6d8ed1&"
import script from "./AdminSupportMessageResource.vue?vue&type=script&lang=js&"
export * from "./AdminSupportMessageResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports